import { Component, OnInit } from '@angular/core';
import { DataService } from '../../data.service';
import { GeneralService } from '../../general.service';
import { ResizeEvent } from 'angular-resizable-element';
import {TranslateService} from '@ngx-translate/core';


@Component({
  selector: 'app-media-holder',
  styles: [
    `
    mwlResizable {
      box-sizing: border-box; // required for the enableGhostResize option to work
    }
  `
  ],
  templateUrl: './media-holder.component.html',
  styleUrls: ['./media-holder.component.scss']
})
export class MediaHolderComponent implements OnInit {

  public currentStyles = {
    
  };

  public clickedImage = {
    Enabled: false,
    ImageUrl: ""
  };

  constructor(
    public dataSvc: DataService,
    public generalSvc: GeneralService,
    public translate: TranslateService
  ) { 
    if(dataSvc != null && dataSvc !== undefined){
    //   var usersLanguage = dataSvc.currentUser.Language.DotNetCulture.toString().substring(0,2);
    //   if(usersLanguage != null){
    //     translate.setDefaultLang(usersLanguage);
    //     translate.use(usersLanguage);
    //   }
    //   else{
    //     translate.setDefaultLang('en');
    //     translate.use('en');
    //   }
    // }
    // else{
      translate.setDefaultLang('en');
      translate.use('en');
    }
  }

  ngOnInit() {

  }

  

  style: {};

  validateResize(event) {
    //console.log(event);
    return true;
  }

  onResizeEnd(event: ResizeEvent): void {
    
    var newMediaWidth = parseInt(`${event.rectangle.width}`);

    this.currentStyles = {
      'width': parseInt(`${event.rectangle.width}`).toString() + "px",
      'max-width': '50%',
      'min-width': '20%'
    };

    var totalWidth = document.getElementById("container").offsetWidth;
    var newMediaWidth =  (newMediaWidth / totalWidth)  * 100;
    
    var examWidth = 100 - newMediaWidth;
    if(examWidth < 50){
      examWidth = 50;
      newMediaWidth = 50;
    }
    if (examWidth > 80){
      examWidth = 80;
      newMediaWidth = 20;
    }

    var mediaContainer = document.getElementById("mediaContainer");
    mediaContainer.style.width = newMediaWidth + "%";

    var examContainer = document.getElementById("examContainer");
    examContainer.style.width = examWidth + "%";

    // Refresh 
    this.dataSvc.updateViewerHeights();
  }

  openImageViewer(img) {
    this.clickedImage.Enabled = true;
    this.clickedImage.ImageUrl = img;
  }

  closeImageViewer(){
    this.clickedImage.Enabled = false;
    this.clickedImage.ImageUrl = "";
  }

  checkZoom(e, media){
    media.ZoomFactor = this.dataSvc.roundToDecimal(e);
  }

  increaseZoom(media){    
    var img = document.getElementById("zoom");
    if(img != null){
      if(media.ZoomFactor == null || media.ZoomFactor == undefined){
        media.ZoomFactor = 1;
      }
      img.style.zoom = media.ZoomFactor + 0.1
      media.ZoomFactor = media.ZoomFactor + 0.1;   
      return media;   
    }
  }

  decreaseZoom(media){
    var img = document.getElementById("zoom");
    if(img != null){
      if(media.ZoomFactor == null || media.ZoomFactor == undefined){
        media.ZoomFactor = 1;
      }
      if(media.ZoomFactor > 0.1){
        img.style.zoom = (media.ZoomFactor - 0.1).toString();
        media.ZoomFactor = (media.ZoomFactor - 0.1);   
        return media; 
      }
    }
  }

  resize(e){

  }
}